import { RoutePath } from 'config/routes';
import { ContentHubSlugs } from 'types/contentHubs';

export type DeepLinkUrlArgs = {
  season?: string | number;
};

export const createDeepLinkUrl = (
  route: RoutePath,
  id: string,
  args?: DeepLinkUrlArgs,
) => {
  let url = '';
  switch (route) {
    case RoutePath.PLAY: {
      url = `${route}/show/${id}`;
      break;
    }
    case RoutePath.SERIES_DETAIL: {
      const season = args?.season;
      url = `${route}/${id}/${season ? season : ''}`;
      break;
    }
    case RoutePath.CONTENT_HUB: {
      const isNested = id !== ContentHubSlugs.HOME;
      url = `${route}/${id}${isNested ? '/true' : ''}`;
      break;
    }
    case RoutePath.MOVIE_DETAIL:
    case RoutePath.LIVE_EVENT_DETAIL:
    case RoutePath.EPG: {
      url = `${route}/${id}`;
      break;
    }
    case RoutePath.SEARCH: {
      url = `${route}`;
      break;
    }
  }

  return url;
};
